import { Component } from '@angular/core';
import { OngletlayoutComponent } from "../../../../components/layouts/ongletlayout/ongletlayout.component";
import { routeAlias } from '../../../../../routesalias';
import { RouterOutlet } from '@angular/router';
import { closeLocalStorage } from '../../../../utils/helpers';

@Component({
  selector: 'app-activities',
  imports: [OngletlayoutComponent, RouterOutlet],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.css'
})
export class ActivitiesComponent {

  /*
  // Ancienne logique de navigation manuelle (ActivitelayoutComponent)
  // remplacée par la persistance dans OngletlayoutComponent
  //
  // ngOnInit(): void {
  //   const roles = this.authService.getUserRoles() || [];
  //   if (roles.includes('SU')) {
  //     this.router.navigate([routeAlias.parameters.home, routeAlias.parameters.activity.home, routeAlias.parameters.activity.type_activite.home]);
  //     return;
  //   }
  //   if (roles.includes('PRMP')) {
  //     this.router.navigate([routeAlias.parameters.home, routeAlias.parameters.marches.home]);
  //     return;
  //   }
  //   this.router.navigate([routeAlias.parameters.home, routeAlias.parameters.activity.home]);
  // }
  */

  onCloseLocalStorage(): void {
    closeLocalStorage();
  }

  tableLinkForActivities = [
    { text: "Type activités",       link: routeAlias.parameters.activity.type_activite.home },
    { text: "Type d'interventions", link: routeAlias.parameters.activity.type_intervention.home },
    { text: "Ligne budgétaire",     link: routeAlias.parameters.activity.ligne_budgetaire.home },
    { text: "Structure",            link: routeAlias.parameters.activity.structure.home },
  ]
}